<template>
  <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
      <c-table
        ref="tableImpr"
        title="개선 목록"
        :columns="gridImpr.columns"
        :editable="disabled"
        :data="result.equipmentImproveModels"
        :merge="gridImpr.merge"
        selection="multiple"
        rowKey="equipImproveId"
        :usePaging="false"
        :isExcelDown="false"
        :filtering="false"
        :columnSetting="false"
      >
        <template slot="table-button">
          <q-btn-group outline >
            <c-btn v-if="disabled" label="추가" :showLoading="false"  icon="add" @btnClicked="addItem" />
            <c-btn
              v-if="disabled && (result.noPlanResultEnrollFlag !== 'Y' && isMultiple) && result.equipmentImproveModels.length > 0"
              :url="insertUrl"
              :isSubmit="isSave"
              :param="result.equipmentImproveModels"
              mappingType="POST"
              label="저장"
              icon="save"
              @beforeAction="saveImprove"
              @btnCallback="saveCallback" 
            />
            <c-btn v-if="disabled && result.equipmentImproveModels.length > 0" label="삭제" :showLoading="false" icon="remove" @btnClicked="removeItem" />
          </q-btn-group>
        </template>
        <template v-if="isMultiple" slot="table-chip">
          <q-btn-group outline >
            <q-chip>
                <q-avatar icon="push_pin" color="blue-6" text-color="white" /> 
                {{ "설비명(관리번호) : " + result.equipmentName + '(' + result.equipmentCd + ')'}}
            </q-chip>
          </q-btn-group>
        </template>
        <template v-slot:customArea="{ props, col }">
          <template v-if="props.row['sopImprovementIds'] && props.row['ibmStepNames']">
            <q-chip
              v-for="(item, index) in chipDatas(props.row['sopImprovementIds'], props.row['ibmStepNames'], props.row['ibmClassCds'])"
              :key="index"
              :color="item.color"
              :clickable="true"
              text-color="white"
              style="margin-bottom:4px !important;"
              @click="linkClick(item, props.row)">
              {{item.title}}
            </q-chip>
          </template>
          <div v-if="props.row.editFlag!=='C'">
            <q-btn-group outline class="ColumInnerBtnGroup">
              <q-btn
                v-if="disabled"
                icon="add"
                color="red-6"
                text-color="white"
                class="ColumInnerBtn"
                align="center"
                @click.prevent="innerBtnClicked(col, props, '1')">
                <q-tooltip>
                  개선요청등록
                </q-tooltip>
              </q-btn>
              <q-btn
                v-if="disabled"
                icon="add"
                color="light-blue"
                text-color="white"
                class="ColumInnerBtn"
                align="center"
                @click.prevent="innerBtnClicked(col, props, '2')">
                <q-tooltip>
                  즉시조치등록
                </q-tooltip>
              </q-btn>
            </q-btn-group>
          </div>
        </template>
      </c-table>
    </div>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>
<script>
import { v4 as uuidv4 } from 'uuid';
import selectConfig from '@/js/selectConfig';
import transactionConfig from '@/js/transactionConfig';
export default {
  name: 'hazard-cause-prevention',
  props: {
    result: {
      type: Object,
      default: () => ({
        equipmentCd: '',
        equipmentName: '',
        checkStatusCd: '',
        minEquipmentCheckId: '',
        equipmentResultList: [],
        noPlanResultEnrollFlag: 'N',
      }),
    },
    isMultiple: {
      type: Boolean,
      default: false,
    },
    count: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      editable: true,
      equipInfo: {
        plantName: '',
        machineryClassificationName: '',
        itemNo: '',
        machineryName: '',
        emplacementMonth: '',
        inspectionSubjectFlagName: '',
        inspectionCycleName: '',
        gradeName: '',
        resultName: '',
        departmentDeptName: '',
        departmentUserName: '',
        inspectionKindName: '',
      },
      gridImpr: {
        columns: [
          {
            required: true,
            name: 'locationDetail',
            field: 'locationDetail',
            label: '세부위치',
            align: 'left',
            type: 'text',
            style: 'width:25%',
            sortable: false,
          },
          {
            required: true,
            name: 'findings',
            field: 'findings',
            label: '발견사항',
            align: 'left',
            type: 'text',
            style: 'width:25%',
            sortable: false,
          },
          {
            name: 'impr',
            field: 'impr',
            label: '개선진행',
            align: 'center',
            child: [
              {
                name: 'customCol',
                field: 'customCol',
                label: '개선번호/개선진행상태',
                align: 'center',
                style: 'width:20%',
                type: 'custom',
                sortable: false
              },
              {
                name: 'improveMeasures',
                field: 'improveMeasures',
                label: '개선대책',
                align: 'left',
                style: 'width:20%',
                type: 'text',
                sortable: false
              },
            ]
          },
          {
            name: 'equipTypeName',
            field: 'equipTypeName',
            label: '구분',
            align: 'center',
            style: 'width:10%',
            sortable: false,
          },
        ],
        
        data: [],
        height: '200px'
      },
      popupOptions: {
        target: null,
        title: '',
        visible: false,
        width: '80%',
        popupParam: {},
        closeCallback: null,
      },
      isSave: false,
      checkCdItems: [], // 검사결과
      getUrl: '',
      items: [],
      getStdUrl: '',
      insertUrl: '',
      deleteUrl: '',
      colorItems: [],
      component: null,
    };
    
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
  },
  mounted() {
    Object.assign(this.$data, this.$options.data());
    this.init();
  },
  beforeDestroy() {
  },
  computed: {
    disabled() {
      return this.editable && this.result.checkStatusCd!=='MCSC000015'
    },
  },
  watch: {
    'count'() {
      this.getDetail();
    }
  },
  methods: {
    init() {
      this.$comm.getStepItems('IBM_STEP_CD').then(_result => {
        this.colorItems = _result
      });
      this.editable = this.$route.meta.editable;
      this.getUrl = selectConfig.sop.min.equipment.improve.get.url;
      this.insertUrl = transactionConfig.sop.min.equipment.improve.insert.url;
      this.deleteUrl = transactionConfig.sop.min.equipment.improve.delete.url;
      
    },
    getDetail() {
      if (this.result.minEquipmentCheckId) {
        this.$http.url = this.$format(this.getUrl, this.result.minEquipmentCheckId, this.result.equipmentCd);
        this.$http.type = 'GET';
        this.$http.request((_result) => {
          this.result.equipmentImproveModels = this.$_.clone(_result.data);
        },);
      }
    },
    /* eslint-disable no-unused-vars */
    innerBtnClicked(col, props, btn) {
      this.requestImprRow = props.row
      let requestContents = props.row.equipmentName;
      if (btn === '1') {
        this.popupOptions.title = '개선 요청';
        this.popupOptions.param = {
          requestContents: this.result.equipmentName + '(' + this.result.equipmentCd + ')',
          relationTableKey: props.row.equipImproveId,
          ibmTaskTypeCd: props.row.equipTypeCd === '1' ? 'ITT0000055' : 'ITT0000050',
        };
        this.popupOptions.target = () => import(`${'@/pages/sop/ibm/imprRequest.vue'}`);
        this.popupOptions.width = '80%';
        this.popupOptions.visible = true;
        this.popupOptions.closeCallback = this.closeAddImprPopup;
      } else {
        this.popupOptions.title = '즉시조치';
        this.popupOptions.param = {
          requestContents: this.result.equipmentName + '(' + this.result.equipmentCd + ')',
          relationTableKey: props.row.equipImproveId,
          ibmTaskTypeCd: props.row.equipTypeCd === '1' ? 'ITT0000055' : 'ITT0000050',
        };
        this.popupOptions.target = () => import(`${'@/pages/sop/ibm/imprImmediate.vue'}`);
        this.popupOptions.width = '80%';
        this.popupOptions.visible = true;
        this.popupOptions.closeCallback = this.closeAddImprPopup;
      }
    },
    closeAddImprPopup(data) {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;

      if (data && data.length > 0) {
        this.getDetail();
        this.$refs['tableImpr'].$refs['compo-table'].resetVirtualScroll();
      }
    },
    linkClick(data, row) {
      this.requestImprRow = row
      this.imprData = data;

      if (data.ibmClassCd === 'IC00000001') {
        this.popupOptions.title = '개선';
        this.popupOptions.param = {
          sopImprovementId: data.sopImprovementId,
        };
        this.popupOptions.target = () => import(`${'@/pages/sop/ibm/imprDetail.vue'}`);
        this.popupOptions.width = '80%';
        this.popupOptions.visible = true;
        this.popupOptions.closeCallback = this.closeImprPopup;
      } else {
        this.popupOptions.title = '즉시조치';
        this.popupOptions.param = {
          sopImprovementId: data.sopImprovementId,
        };
        this.popupOptions.target = () => import(`${'@/pages/sop/ibm/imprImmDetail.vue'}`);
        this.popupOptions.width = '80%';
        this.popupOptions.visible = true;
        this.popupOptions.closeCallback = this.closeImprPopup;
      }
    },
    closeImprPopup(result) {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      if (result && result.col1) {
        let splitId = this.$_.split(this.requestImprRow.sopImprovementIds, ',');
        let splitStep = this.$_.split(this.requestImprRow.ibmStepNames, ',');
        if (splitId && splitId.length > 0) {
          let idIndex = this.$_.indexOf(splitId, result.col1.sopImprovementId);
          splitStep[idIndex] = result.col1.ibmStepName;
          this.requestImprRow.ibmStepNames = splitStep.toString();
        }
        this.$refs['tableImpr'].$refs['compo-table'].resetVirtualScroll();
      }
    },
    chipDatas(sopImprovementIds, ibmStepNames, ibmClassCds) {
      let returnData = [];
      let splitId = this.$_.split(sopImprovementIds, ',');
      let splitStep = this.$_.split(ibmStepNames, ',');
      let splitClass = this.$_.split(ibmClassCds, ',');

      if (splitId.length === splitStep.length) {
        let i = 0;
        this.$_.forEach(splitId, item => {
          let color = this.$_.find(this.colorItems, { stepperMstNm: splitStep[i] });
          returnData.push({
            title: splitClass[i] === 'IC00000001' ? item + ' / ' + splitStep[i] : item + ' / 즉시조치',
            color: color ? color.colorClass : '',
            sopImprovementId: item,
            ibmClassCd: splitClass[i] === 'IC00000001' ? 'IC00000001' : 'IC00000005',
          });
          i++;
        });
      }
      return returnData;
    },
    addItem() {
      this.result.equipmentImproveModels.splice(0, 0, {
        minEquipmentCheckId: this.result.minEquipmentCheckId,
        equipImproveId: uuidv4(),
        locationDetail: '',
        equipTypeCd: '1',
        improvingMeasures: '',
        sopImprovementIds: '', 
        ibmStepNames: '', 
        improveMeasures: '',
        findings: '',
        editFlag: 'C',
        fileNm: '',
      })
    },
    removeItem() {
      let selectData = this.$refs['tableImpr'].selected;
      if (!selectData || selectData.length === 0) {
        window.getApp.$emit('ALERT', {
          title: '안내', // 안내
          message: '하나 이상 선택하세요.', // 하나 이상 선택하세요.
          type: 'warning', // success / info / warning / error
        });
      } else {
        window.getApp.$emit('CONFIRM', {
        title: '확인',
        message: '삭제하시겠습니까?',
        // TODO : 필요시 추가하세요.
        type: 'warning', // success / info / warning / error
        // 확인 callback 함수
        confirmCallback: () => {
          this.$http.url = this.deleteUrl;
          this.$http.type = 'DELETE';
          this.$http.param = {
            data: Object.values(selectData)
          }
          this.$http.request((_result) => {
            this.$_.forEach(selectData, item => {
              this.result.equipmentImproveModels = this.$_.reject(this.result.equipmentImproveModels, { equipImproveId: item.equipImproveId })
            })
            window.getApp.$emit('APP_REQUEST_SUCCESS');
          },);
        },
        // 취소 callback 함수
        cancelCallback: () => {
        },
      });
      }
    },
    saveImprove() {
      let isConti = true;
      let checkItem = ['locationDetail', 'findings' ]
      this.$_.forEach(this.result.equipmentImproveModels, item => {
        this.$_.forEach(checkItem, check => {
          if (!item[check]) {
            isConti = false;
            return false;
          }
        })
      });
      if (!isConti) {
        window.getApp.$emit('ALERT', {
          title: '안내', // 안내
          message: '필수 입력값을 입력해 주세요. [세부위치, 발견사항]',
          type: 'warning', // success / info / warning / error
        });
      } else {
        window.getApp.$emit('CONFIRM', {
          title: '확인',
          message: '저장하시겠습니까?',
          // TODO : 필요시 추가하세요.
          type: 'info', // success / info / warning / error
          // 확인 callback 함수
          confirmCallback: () => {
            this.isSave = !this.isSave;
          },
          // 취소 callback 함수
          cancelCallback: () => {
          },
        });
      } 
    },
    saveCallback() {
      window.getApp.$emit('APP_REQUEST_SUCCESS');
      this.getDetail();
    },
  }
};
</script>